export default {
  mounted (el: any, binding: any) {
    const onClickOutside = (event: any) => {
      if (!el.contains(event.target) && el !== event.target) {
        binding.value(event)
      }
    }
    document.addEventListener('click', onClickOutside)
    el._clickOutside = onClickOutside
  },
  unmounted (el: any) {
    document.removeEventListener('click', el._clickOutside)
  }
}
